.segmentBreadcrumbWrapper {
  position: sticky;
  top: 0;
  background-color: var(--sparky-background);
  padding-inline: 48px;
  height: auto;
  padding-block: 14px;
  z-index: 3;
}
